import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { ExamRequest } from '../exam/exam-request';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class ExamRequestService {

  private examsUrl = 'api/exam_requests';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  searchExamRequestsByPatientId(patientId: number): Observable<ExamRequest[]> {
    if (patientId < 1) { return of([]); }
    return this.http
      .get<ExamRequest[]>(`${this.examsUrl}/?patientId=${patientId}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  createExamRequest(examRequest: ExamRequest): Observable<ExamRequest> {
    return this.http
      .post<ExamRequest>(this.examsUrl, examRequest, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getNextSadtNumber(): Observable<number> {
    return this.http
      .get<number>(`${this.examsUrl}/next_sadt_number`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
